import { Link } from 'react-router-dom';
import { AppShell, FootNav, Avatar, Button, useTheme } from '@dreamtree-org/twreact-ui';
import { LogOut, Moon, Sun } from 'lucide-react';
import RouterLink from './RouterLink';

/**
 * The staff shell for the back office, the service portal and the platform console (D50):
 * twreact-ui AppShell — sidebar from lg, a drawer from the top-bar menu below lg, and a FootNav of
 * the busiest destinations on phones. min-h-dvh, safe areas and focus handling come from AppShell.
 *
 *   nav     [{ id, label, href, icon, group, active, count }]  (already permission-filtered)
 *   foot    FootNav items [{ id, label, to, icon, active, variant }]
 *   actions extra top-bar controls (left of theme / sign out / avatar)
 *
 * AppShell's drawer is uncontrolled, so there is no FootNav "More" tab; the menu button opens it.
 * Upstream: twreact-ui issue "AppShell: controlled drawer + tablet sidebar" (B14).
 */
export default function StaffShell({ brand, nav, foot, actions, user, onLogout, pageTitle, children }) {
  const { toggleTheme, isDark } = useTheme();
  return (
    <AppShell
      brand={brand}
      nav={nav}
      linkAs={RouterLink}
      pageTitle={pageTitle}
      data-testid="staff-shell"
      topbar={
        <div className="flex items-center gap-1">
          {actions}
          <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label={isDark ? 'Use light mode' : 'Use dark mode'}>
            {isDark ? <Sun size={18} aria-hidden /> : <Moon size={18} aria-hidden />}
          </Button>
          {onLogout ? (
            <Button variant="ghost" size="icon" onClick={onLogout} aria-label="Sign out">
              <LogOut size={18} aria-hidden />
            </Button>
          ) : null}
          {user ? <Avatar name={user.name || user.email || 'Staff'} size="sm" className="ml-1" /> : null}
        </div>
      }
      bottomNav={foot && foot.length ? <FootNav items={foot} linkAs={Link} data-testid="footnav" /> : null}
    >
      {children}
    </AppShell>
  );
}
